import styled from '@emotion/styled';
import { Section } from 'components/commons/Section';
import Image from 'next/image';
import React from 'react';
import { theme } from 'styles/theme';
import { Address } from './Address';
import { ContactForm } from './ContactForm';

const CustomSection = styled(Section)`
  margin-top: -5rem;
  flex-wrap: wrap-reverse;
`;

const Aside = styled.aside<{ backgroundColor?: string; flex: string }>`
  position: relative;
  display: flex;
  flex: 1;
  min-width: 100%;
  ${({ flex }) => ({
    [theme.mediaQueries.md]: {
      flex,
      justifyContent: 'center',
      minWidth: 'unset',
    },
  })};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'transparent'};
`;

const ImageWrapper = styled.div`
  display: none;
  position: absolute;
  z-index: 1;
  left: 50%;
  transform: translate(-50%);
  top: -29rem;
  margin-top: 10rem;
  ${{
    [theme.mediaQueries.md]: {
      display: 'block',
    },
  }}
`;

export const Section1 = () => {
  return (
    <CustomSection>
      <Aside backgroundColor={theme.colors.lightBlueGreen} flex="1">
        <ImageWrapper>
          <Image
            src="/assets/pictos/illus_contact.svg"
            alt="Contact icon"
            height={250}
            width={250}
            priority
            layout="fixed"
          />
        </ImageWrapper>
        <Address />
      </Aside>
      <Aside flex="2">
        <ContactForm />
      </Aside>
    </CustomSection>
  );
};
